/**
 * Labstep
 *
 * @module components/Device/Card/EmptyState/Template
 * @desc Empty state for device template
 */

import { DeviceActionCreate } from 'labstep-web/components/Device/Action/Create';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Device } from 'labstep-web/models/device.model';
import type React from 'react';
import { useMemo } from 'react';

export const DeviceCardEmptyStateTemplate: React.FC = () => {
  const action = useMemo(() => <DeviceActionCreate isTemplate />, []);
  return (
    <CardEmptyState
      title={`No ${Device.getHumanReadableEntityName(
        true,
        true,
        true,
      )}`}
      explanation={`${Device.getHumanReadableEntityName(
        true,
        true,
        true,
      )} are customisable metadata templates to apply to device. This makes it easy to upload and manage device with the same descriptive information.`}
      src="/img/empty-state/inventory.svg"
      action={action}
    />
  );
};
